export const getCampaigns = (state) => state.collect.campaigns;
export const getAssignments = (state) => state.collect.assignments;
export const getAssignmentsRaw = (state) => state.collect.assignments?.raw;
export const getRevisits = (state) => state.collect.revisit;
export const getRevisitCount = (state) => state.collect.revisitCount;
export const getCollectCount = (state) => state.collect.collectCount;
export const getOfflineAssignments = (state) => state.collect.offlineAssignments;
export const getUnsyncedSurveys = (state) => state.collect.unsyncedSurveys;
